module.exports = __webpack_public_path__ + "GoldCoastNannies_Logo_FullColor-01.png?c336883543078f07cbfbc1496457ab03";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/GoldCoastNannies_Logo_FullColor-01.png
// module id = 72
// module chunks = 0